import classnames from 'classnames';
import TapeRoll from 'components/Icons/TapeRoll';
import React from 'react';
import { ViewPunchList } from 'records/interactions/ViewPunchList';
import { Sheet } from 'records/Sheet';
import withAppStore, { WithAppStoreProps } from 'utils/withAppStore';
import { useTranslator } from '@bluebeam/react-i18n';

interface Props extends WithAppStoreProps {
  sheet: Sheet;
}

const HeaderPunchTab = (props: Props) => {
  const { translate } = useTranslator(['mapView', 'buttons']);
  const handlePunchToggleClick = (): void => {
    const { sheet, actions } = props;

    if (isUpdatePunchOrPunchListOpen()) {
      actions.clearInteractions();
    } else {
      const interaction = new ViewPunchList({
        sheet,
      });
      actions.clearInteractions();
      actions.createInteraction(interaction);
    }
  };

  const isUpdatePunchOrPunchListOpen = (): boolean => {
    const { appState } = props;
    return (
      appState.interactions.find(
        (i) => i.type === 'ViewPunchList' || i.type === 'UpdatePunch'
      ) !== undefined
    );
  };

  const punchOverlayOpen = isUpdatePunchOrPunchListOpen();

  return (
    <div
      data-testid="header-punch-tab"
      className={classnames('h100 ws3 flex-center cursor-pointer', {
        'bgd-gray-1 fill-primary color-primary': !punchOverlayOpen,
        'bgd-primary fill-white color-white': punchOverlayOpen,
      })}
      onClick={handlePunchToggleClick}
    >
      <div className="column items-center">
        <div className="wrem-1p5 hrem-1p5 flex-center">
          <TapeRoll width="16px" height="16px" />
        </div>
        <div style={{ fontSize: '6px' }}>
          {translate('mapView:mapPageSubheader.punch').toUpperCase()}
        </div>
      </div>
    </div>
  );
};

export default withAppStore<Props>(HeaderPunchTab);
